import { Entity } from '../entity.js';
import { EFFECT_TYPES } from '../combat/statusEffects.js';
import { isInAbilityCircle, isWithinAbilityRange } from '../combat/abilityArea.js';

export function createLulu(id = 'lulu-1', team = 'blue', x = 300, y = 1300) {
  const lulu = new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 552,
    maxMp: 470,
    ad: 48,
    ap: 0,
    armor: 28,
    mr: 30,
    ms: 330,
    attackRange: 550,
    attackSpeed: 0.625,
    name: 'Lulu',
    radius: 20
  });
  lulu.pixShieldHp = 0;
  return lulu;
}

export function castLuluQ(caster, targetX, targetY, projectiles, gameTime) {
  if (!caster || caster.isDead || caster.mp < 50) return false;
  caster.mp -= 50;
  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  const damage = 50 + (caster.ap || 0) * 0.5;
  projectiles.push({
    id: `lulu-q-${caster.id}-${gameTime}`,
    casterId: caster.id,
    team: caster.team,
    x: caster.x,
    y: caster.y,
    vx: Math.cos(angle) * 1450,
    vy: Math.sin(angle) * 1450,
    range: 950,
    traveled: 0,
    damage,
    damageType: 'magic',
    radius: 60,
    onHitStatus: EFFECT_TYPES.SLOW
  });
  return true;
}

export function castLuluW(caster, selectedTarget = null) {
  if (!caster || caster.isDead || caster.mp < 65) return false;
  const target = selectedTarget && !selectedTarget.isDead ? selectedTarget : caster;
  if (target !== caster && !isWithinAbilityRange(caster, target, 650, caster)) return false;
  caster.mp -= 65;
  if (target.team === caster.team) {
    target.ms += 60;
    target.whimsyActive = true;
    return true;
  }
  target.statusManager?.addEffect?.(EFFECT_TYPES.SILENCE, 1.25, 0);
  return true;
}

export function castLuluE(caster, selectedTarget = null) {
  if (!caster || caster.isDead || caster.mp < 60) return false;
  const target = selectedTarget
    && selectedTarget.team === caster.team
    && !selectedTarget.isDead
    ? selectedTarget
    : caster;
  if (target !== caster && !isWithinAbilityRange(caster, target, 650, caster)) return false;
  caster.mp -= 60;
  const shield = 65 + (caster.ap || 0) * 0.4;
  target.shieldHp = (target.shieldHp || 0) + shield;
  if (target === caster) caster.pixShieldHp = shield;
  return true;
}

export function castLuluR(caster, entities = [], selectedTarget = null) {
  if (!caster || caster.isDead || caster.mp < 100) return false;
  const ally = selectedTarget
    && selectedTarget.team === caster.team
    && !selectedTarget.isDead
    ? selectedTarget
    : caster;
  if (ally !== caster && !isWithinAbilityRange(caster, ally, 900, caster)) return false;
  caster.mp -= 100;
  ally.maxHp += 150;
  ally.hp = Math.min(ally.maxHp, ally.hp + 150);
  for (const e of entities) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, ally.x, ally.y, 400, caster)) continue;
    e.statusManager?.addEffect?.(EFFECT_TYPES.KNOCKUP, 1.0, 1);
  }
  return true;
}
